// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Scheduler } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteScheduler(): (
  schedulerId: string
) => Promise<Scheduler> {
  const getAPI = useGetApi();
  return useCallback(
    async (schedulerId) =>
      (await getAPI()).schedulers.deleteScheduler({ schedulerId }),
    [getAPI]
  );
}
